import React, { useState } from "react";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { useApiRequest } from "@utils/ApiRequest";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@libs/reactQuery/queryClient";

const LikeButtonContainer = styled.button`
  animation: ${({ liked }: { liked: boolean }) =>
    liked ? "bounce 0.3s" : "none"};

  @keyframes bounce {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
  }
`;
type Props = {
  white?: boolean;
  isLiked: boolean;
  id: number;
  type: "brand" | "product";
};
const LikeButton = ({ white, isLiked, id, type }: Props) => {
  const { patchBrandLike, patchProductLike } = useApiRequest();

  const handleLike = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    mutate();
  };

  const { mutate } = useMutation({
    mutationFn: () =>
      type === "brand" ? patchBrandLike(id) : patchProductLike(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [type === "brand" ? "brandDetail" : "productInfo"],
      });

      await queryClient.invalidateQueries({
        queryKey: [type === "brand" && "brandList"],
      });
    },
  });

  const theme = useTheme();

  return (
    <LikeButtonContainer onClick={handleLike} liked={isLiked}>
      <Image
        src={
          isLiked
            ? theme.image.like_full.default
            : white
              ? theme.image.love_icon_white.default
              : theme.image.like.default
        }
      />
    </LikeButtonContainer>
  );
};

export default LikeButton;
